var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-eye-4989205 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0004 9.50703C10.406 9.50703 9.92478 9.99282 9.92478 10.5912C9.92478 11.1904 10.4067 11.6754 11.0004 11.6754C11.5949 11.6754 12.0761 11.1897 12.0761 10.5912C12.0761 9.99205 11.5941 9.50703 11.0004 9.50703ZM20.3318 10.5912C19.4656 9.46312 18.5139 8.52391 17.506 7.77206C16.8509 7.28312 16.1715 6.87403 15.4754 6.54416C16.4316 7.61686 17.0132 9.03543 17.0132 10.5914C17.0132 12.1466 16.4316 13.5659 15.4754 14.6386C16.1715 14.3088 16.8508 13.8997 17.506 13.4107C18.5147 12.6589 19.4657 11.7186 20.3318 10.5912ZM11.0305 5.51705H10.9716C9.59352 5.52484 8.34591 6.09108 7.44147 7.00272C6.53063 7.92081 5.96691 9.18932 5.96691 10.5905C5.96691 11.9917 6.53002 13.2603 7.44147 14.1783C8.34591 15.0899 9.59352 15.6562 10.9716 15.664H11.0305C12.4086 15.6562 13.6562 15.0899 14.5607 14.1783C15.4715 13.2602 16.0352 11.9917 16.0352 10.5905C16.0352 9.18932 15.4721 7.92069 14.5607 7.00272C13.6562 6.09108 12.4086 5.52483 11.0305 5.51705ZM6.52632 6.54404C5.83021 6.8739 5.15092 7.28301 4.49567 7.77194C3.48701 8.52375 2.53604 9.46373 1.66994 10.5911C2.53608 11.7192 3.48778 12.6585 4.49567 13.4103C5.15076 13.8992 5.83021 14.3083 6.52632 14.6382C5.57014 13.5655 4.98846 12.1462 4.98846 10.591C4.98846 9.03504 5.57014 7.61679 6.52632 6.54404ZM11.0004 4.53139C11.0266 4.53139 11.0521 4.53139 11.0785 4.53199C13.5009 4.54877 15.9189 5.3656 18.0867 6.98265C19.2538 7.85296 20.3475 8.95592 21.3286 10.2903C21.4597 10.4597 21.468 10.7033 21.335 10.8842C20.3527 12.2224 19.2565 13.3279 18.0873 14.2001C15.9194 15.8166 13.5014 16.6334 11.0791 16.6508C11.0529 16.6508 11.0273 16.6514 11.001 16.6514C10.9749 16.6514 10.9493 16.6514 10.923 16.6508C8.50061 16.634 6.08253 15.8172 3.91472 14.2001C2.74765 13.3298 1.65401 12.2269 0.672861 10.8925C0.541785 10.7231 0.53346 10.4795 0.666471 10.2986C1.6488 8.96041 2.74499 7.85491 3.91412 6.98265C6.08208 5.36621 8.50007 4.54937 10.9224 4.53199C10.9486 4.53199 10.9741 4.53139 11.0004 4.53139Z",
    fill: "#9E9E9E",
    stroke: "#9E9E9E",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 157",
    x: 0.758469,
    y: 15.4408,
    width: 22.7647,
    height: 1.82,
    rx: 0.91,
    transform: "rotate(-30 0.758469 15.4408)",
    fill: "#9E9E9E",
    stroke: "white",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.dbf0de78b6741cbe938e809eeed9f907.svg";
export { ForwardRef as ReactComponent };